import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable } from "../components/Table";

function scoreColor(s) { return s >= 85 ? "#34C759" : s >= 70 ? "#5AC8FA" : s >= 55 ? "#FF9500" : "#FF3B30"; }

export default function Drivers() {
  const [drivers, setDrivers] = useState([]);
  useEffect(() => { api.get("/drivers").then((r) => setDrivers(r.data.drivers)); }, []);

  const columns = [
    { key: "rank", header: "#", render: (r) => <span className="text-muted-foreground">{drivers.indexOf(r) + 1}</span> },
    { key: "name", header: "Driver", render: (r) => <span className="font-semibold">{r.name}</span> },
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-mono text-xs">{r.vehicle_number}</span> },
    { key: "score", header: "Score", render: (r) => (
      <div className="flex items-center gap-2">
        <div className="w-20 h-1.5 bg-secondary rounded-sm overflow-hidden">
          <div className="h-full" style={{ width: `${r.score}%`, background: scoreColor(r.score) }} />
        </div>
        <span className="font-display font-bold" style={{ color: scoreColor(r.score) }}>{r.score}</span>
      </div>
    )},
    { key: "overspeed", header: "Overspeed" },
    { key: "harsh_events", header: "Harsh Events" },
    { key: "distance", header: "Distance", render: (r) => `${r.distance} km` },
    { key: "max_speed", header: "Max Speed", render: (r) => `${r.max_speed} km/h` },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Driver Behaviour" subtitle="Scores based on driving events" />
      <DataTable testid="drivers-table" columns={columns} rows={drivers} />
    </div>
  );
}
